import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const DigiFormField = ({
  type,
  label,
  placeholder,
  name,
  value,
  required,
  step,
  min,
  max,
  fieldErrors,
  onChange
}) => (
  <div
    className={classnames("form-group", {
      "has-error": fieldErrors && fieldErrors.length > 0
    })}
  >
    {label ? (
      <label
        className="control-label word-wrap"
        htmlFor={`input-${name}`}
      >
        {label}
        {required ? " *" : ""}
      </label>
    ) : null}
    <input
      id={`input-${name}`}
      type={type}
      className="form-control"
      placeholder={placeholder}
      name={name}
      value={value || ""}
      step={step}
      min={min}
      max={max}
      onChange={onChange}
      aria-label={label ? label : "Input Field"} 
    />
    {fieldErrors ? <span className="help-block">{fieldErrors.join(", ")}</span> : null}
  </div>
);

DigiFormField.propType = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  fieldErrors: PropTypes.array,
  onChange: PropTypes.func
};

DigiFormField.defaultProps = {
  type: "text",
  required: false
};

export default DigiFormField;
